import Typography from 'components/UI/Typography'
import Heading from 'components/UI/Typography/Heading'
import { useAppSelector } from 'hooks'
import { DecisionViews } from 'pages/Decision/constants'
import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { mainViewSelector, programSelector } from 'redux/store/slices/decisionSlice'
import { getUserRecord } from 'redux/store/slices/userSlice'
import tw from 'twin.macro'
import { getDearUserText, removeExtraWhitespace } from 'utils'

const DecisionHeader = () => {
  // Tools
  const { t } = useTranslation()

  // Selectors
  const { first_name, middle_name, gender } = useAppSelector(getUserRecord)
  const mainView = useAppSelector(mainViewSelector)
  const selectedProgram = useAppSelector(programSelector)

  // Computed values
  const userName = getDearUserText({ gender, first_name, middle_name })

  if (mainView === DecisionViews['CHOOSE-DELIVERY-ADDRESS']) return

  return (
    <div tw='px-4 md:px-0'>
      <Heading variant='title2'>{removeExtraWhitespace(userName)}</Heading>
      {mainView === DecisionViews['LOAN-CONDITIONS'] &&
        (selectedProgram === 'OWN_PROGRAM' ? (
          <Fragment>
            <Typography variant='subbody' twStyle={tw`text-grey-dark mt-2`}>
              {t('flow-own-program-conditions')}
            </Typography>
            <Typography variant='subbody' twStyle={tw`text-grey-dark mt-2`}>
              {t('flow-craft-own')}
            </Typography>
          </Fragment>
        ) : selectedProgram === 'DAMU' ? (
          <Typography variant='subbody' twStyle={tw`text-grey-dark`}>
            {t('damu-pre-aprrove')} <br />
            {t('15-days')}
          </Typography>
        ) : null)}
    </div>
  )
}

export default DecisionHeader
